export const findRow = (rows, rowKey: string) => rows.find((row) => row.dimensions[0] && row.dimensions[0] === rowKey);
export const weekDaysDimensions = (results) => results.reduce((list, row) => {
  const saved = list.find(element => row && row.dimensions && row.dimensions[1] === element[1]);
  if (!saved) {
    list = [...list, row.dimensions];
  }
  return list;
}, []);
export const getRowsResults = (weekResult) => weekResult && weekResult.reports && weekResult.reports[0] && weekResult.reports[0].data && weekResult.reports[0].data.rows ? weekResult.reports[0].data.rows : [];
